import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import classes from '../../../_common/Tables/styles.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';

const header = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'Username',
    path: 'username',
  },
  {
    name: 'Email Address',
    path: 'email',
  },
  {
    name: 'Role',
    path: 'role',
  },
  {
    name: 'Date Added',
    path: 'createdAt',
  },
];

const TeamTable = ({
  data, className, page, limit, totalPage, onChange,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const trClass = [classes.tr];

  if (className) trClass.push(className);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.script_loader_wrapper}>
          { loading && <Loader className={classes.loader_wrapper} />}

          <div className={classes.table_wrapper}>
            <div className={classes.table__border}>
              <table className={classes.table}>

                <thead className={classes.thead}>
                  <tr className={classes.tr}>
                    {header.map((h) => (
                      <th className={classes.th} key={h.name}>{h.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className={classes.tbody}>
                  {data.map((d) => (
                    <tr className={trClass.join(' ')} key={d.id} onClick={() => navigate(`/team/${d.id}/edit`)}>
                      {header.map((h) => (
                        <td className={classes.td} key={h.name}>
                          {h.path === 'createdAt'
                            ? moment(d[h.path]).format('MM/DD/YYYY') : d[h.path]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />

        </div>
      )
  );
};

TeamTable.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

TeamTable.defaultProps = {
  className: '',
};

export default TeamTable;
